import React from 'react'
import {Svg} from '@modifi/ui'

export default ({...props}) => (
  <Svg viewBox="0 0 150 150" {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(5.000000, 41.000000)">
        <polygon
          stroke="#51565C"
          strokeWidth="3.5"
          points="140 75.0396293 135.813084 79.8130841 13.3457944 79.8130841 9.1588785 75.0396293 9.1588785 73.271028 140 73.271028"
        />
        <polygon
          stroke="#51565C"
          strokeWidth="3.5"
          points="17.6635514 73.271028 131.495327 73.271028 131.495327 0 17.6635514 0"
        />
        <rect
          stroke="#51565C"
          strokeWidth="2"
          x="47.7570093"
          y="22.2429907"
          width="54.953271"
          height="34.6728972"
        />
        <path
          d="M57.3414117,42.508044 L36.9439252,42.508044 L36.9439252,37.379098 L57.4066395,37.379098 L51.963657,31.1992756 L55.4298538,28.0115766 L64.5189615,38.331116 C65.3098789,39.2291032 65.3098789,40.5839809 64.5189615,41.4819681 L55.4298538,51.8015075 L51.963657,48.6138085 L57.3414117,42.508044 Z"
          stroke="#FFFFFF"
          strokeWidth="2"
          fill="#51565C"
          fillRule="nonzero"
          transform="translate(51.028037, 39.906542) scale(1, -1) translate(-51.028037, -39.906542) "
        />
        <g transform="translate(0.000000, 22.897196)">
          <rect
            stroke="#FFFFFF"
            strokeWidth="2"
            fill="#53A2D9"
            x="-1"
            y="-1"
            width="35.4754331"
            height="35.4754331"
          />
          <path
            d="M22.6233597,20.6319138 C22.337372,20.4999195 22.0073863,20.4341423 21.6993997,20.4341423 L12.7237884,20.4341423 L12.3938027,18.4980062 L23.701313,18.4980062 L26.033212,10.7323425 L11.0738598,10.7323425 L10.5678817,7.85046729 L6.54205607,7.85046729 L6.54205607,9.23640727 L9.37993318,9.23640727 L11.3378484,20.6759119 C10.1938979,21.2481071 9.73191793,22.6340471 10.2818941,23.7779975 C10.8318703,24.921728 12.2398093,25.383928 13.3837598,24.8339518 C14.4837122,24.2839756 14.9676912,22.9640328 14.4837122,21.8198623 L19.5874911,21.8198623 C19.081513,22.9858118 19.6094902,24.3497528 20.7756597,24.8557309 C21.9413892,25.3617089 23.3055501,24.8339518 23.8113082,23.6680023 C24.3392853,22.5018328 23.7893092,21.1381119 22.6233597,20.6319138"
            fill="#FFFFFF"
          />
        </g>
      </g>
    </g>
  </Svg>
)
